import * as Icons from "lucide-react";

const TILES = [
  ["Sun", "#F59E0B", "Energia"], ["Hotel", "#0EA5E9", "Turismo"], ["Cpu", "#8B5CF6", "Digitale"], ["Waves", "#06B6D4", "Balneari"], ["Tractor", "#84CC16", "Agricoltura"], ["Store", "#F97316", "Commercio"],
  ["Hammer", "#EAB308", "Edilizia"], ["Truck", "#22C55E", "Mobilità"], ["Leaf", "#10B981", "ESG"], ["Receipt", "#F43F5E", "Crediti d'imposta"], ["Landmark", "#3B82F6", "Finanziamenti"], ["Gift", "#A855F7", "Fondo perduto"],
  ["Briefcase", "#14B8A6", "Professionisti"], ["Users", "#F59E0B", "Personale"], ["FileCheck2", "#0EA5E9", "Pratiche"], ["Target", "#EF4444", "Matching ATECO"], ["Megaphone", "#8B5CF6", "Promozione"], ["Building2", "#64748B", "Imprese"],
];

export function HeroMosaic() {
  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="home-hero-mosaic">
      <div className="absolute inset-0 bg-white" />
      <div className="absolute -inset-[6%] grid grid-cols-6 gap-4 opacity-60" style={{ filter: "blur(1.2px)", transform: "rotate(-6deg) scale(1.08)" }}>
        {TILES.map(([ic, col, label], i) => { const Icon = Icons[ic] || Icons.Sparkles; return (
          <div key={label} className="rounded-3xl border border-slate-200 bg-white flex flex-col items-start justify-end p-5 min-h-[150px] hero-tile" style={{ background: `linear-gradient(145deg, ${col}22, ${col}0D 60%, ${col}05)`, animationDelay: `${(i % 6) * 0.6 + Math.floor(i / 6) * 0.3}s` }}>
            <Icon size={44} style={{ color: col }} strokeWidth={1.6} />
            <span className="mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</span>
          </div>); })}
      </div>
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 25% 40%, rgba(0,112,186,.10), transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(0,48,135,.08), transparent 50%)" }} />
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white" />
    </div>
  );
}
